<div class="model-garden-page">
  <header class="garden-header">
    <h1>AI Lineup</h1>
    <p>Browse a category & select any AI model to start a new Chat.</p>
  </header>

  <section class="category-grid-wrap">
    <div class="category-grid">
      <button
        type="button"
        class="category-card"
        *ngFor="let category of visibleCategories"
        [class.active]="category.id === selectedCategoryId"
        (click)="selectCategory(category.id)">
        <div class="category-card-header">
          <h2>{{ category.title }}</h2>
          <span>{{ category.models.length }} models</span>
        </div>

        <div class="category-preview-grid">
          <article class="preview-item" *ngFor="let model of category.models | slice:0:4">
            <img [src]="model.image" [alt]="gardenModelAriaLabel(model) + ' icon'" />
            <div class="preview-copy">
              <h3 *ngIf="isCommandLightGardenModel(model)" class="command-instruct-headline">
                <span class="command-instruct-display" title="Command Instruct">
                  <span class="command-loop-symbol" aria-hidden="true">⌘</span>
                  <span class="command-instruct-text">Instruct</span>
                </span>
              </h3>
              <h3 *ngIf="!isCommandLightGardenModel(model)">{{ model.name }}</h3>
              <p>{{ model.provider }}</p>
            </div>
          </article>
        </div>
      </button>
    </div>

    <div class="page-arrows category-arrows">
      <button type="button" class="page-arrow" [disabled]="!hasPreviousCategoryCards()" (click)="showPreviousCategoryCards()">
        <i class="fa-solid fa-circle-chevron-left"></i>
        Previous
      </button>
      <button type="button" class="page-arrow" [disabled]="!hasNextCategoryCards()" (click)="showNextCategoryCards()">
        Next
        <i class="fa-solid fa-circle-chevron-right"></i>
      </button>
    </div>
  </section>

  <section class="model-gallery" *ngIf="selectedCategory as activeCategory">
    <div class="gallery-header">
      <h2>{{ activeCategory.title }}</h2>
      <p>{{ activeCategory.subtitle }}</p>
      <p>Showing {{ getVisibleModels(activeCategory).length }} of {{ activeCategory.models.length }} models</p>
    </div>

    <div class="gallery-slider-wrap">
      <button type="button" class="slide-arrow left" *ngIf="canSlidePrevious(activeCategory)" (click)="slidePrevious(activeCategory)">
        <i class="fa-solid fa-chevron-left"></i>
      </button>

      <div class="gallery-viewport">
        <div class="gallery-track" [style.transform]="getSliderTransform(activeCategory)">
          <article
            class="model-card"
            *ngFor="let model of getVisibleModels(activeCategory)">
            <img [src]="model.image" [alt]="gardenModelAriaLabel(model) + ' logo'" />
            <div class="model-meta">
              <h3 *ngIf="isCommandLightGardenModel(model)" class="command-instruct-headline">
                <span class="command-instruct-display" title="Command Instruct">
                  <span class="command-loop-symbol" aria-hidden="true">⌘</span>
                  <span class="command-instruct-text">Instruct</span>
                </span>
              </h3>
              <h3 *ngIf="!isCommandLightGardenModel(model)">{{ model.name }}</h3>
              <span>{{ model.provider }}</span>
              <p>{{ model.blurb }}</p>
            </div>
            <div class="model-actions">
              <button
                *ngIf="shouldShowChatButton(activeCategory, model)"
                type="button"
                class="open-model-btn"
                (click)="openModel(model)">Chat</button>
              <button type="button" class="more-model-btn" (click)="openModelBio(model)">More</button>
            </div>
          </article>
        </div>
      </div>

      <button type="button" class="slide-arrow right" *ngIf="canSlideNext(activeCategory)" (click)="slideNext(activeCategory)">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>

    <div class="page-arrows">
      <button type="button" class="page-arrow" [disabled]="!hasPreviousPage(activeCategory)" (click)="goToPreviousPage(activeCategory)">
        <i class="fa-solid fa-circle-chevron-left"></i>
        Previous
      </button>
      <button type="button" class="page-arrow" [disabled]="!hasNextPage(activeCategory)" (click)="goToNextPage(activeCategory)">
        Next
        <i class="fa-solid fa-circle-chevron-right"></i>
      </button>
    </div>
  </section>
</div>
